(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptCategorySearch', RptCategorySearch);

    RptCategorySearch.$inject = ['$resource'];

    function RptCategorySearch($resource) {
        var resourceUrl =  'api/_search/rpt-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
